// https://github.com/vuejs/vue-router/issues/1849
export default {
	created() {
		this.replacePath = () => {
			const currentPath = window.location.hash.slice(1);
			if (this.$route.fullPath !== currentPath)
				this.$router.replace(currentPath);
		};

		// true if browser is IE11
		this.isIE11 = "-ms-scroll-limit" in document.documentElement.style &&
		              "-ms-ime-align" in document.documentElement.style;

		if (this.isIE11)
			window.addEventListener("hashchange", this.replacePath);
	},
	beforeDestroy() {
		if (this.isIE11)
			window.removeEventListener("hashchange", this.replacePath);
	}
};
